const GRAVATAR_URL_CACHE = new Map<string, string>()
const GRAVATAR_AVAILABILITY_CACHE = new Map<string, boolean>()

async function digestMessage(message: string): Promise<string> {
  const encodedMessage = new TextEncoder().encode(message)
  const hashBuffer = await crypto.subtle.digest("SHA-256", encodedMessage)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map((value) => value.toString(16).padStart(2, "0")).join("")
}

function preloadImage(url: string): Promise<boolean> {
  if (typeof Image === "undefined") return Promise.resolve(false)

  return new Promise((resolve) => {
    const image = new Image()
    image.onload = () => resolve(true)
    image.onerror = () => resolve(false)
    image.src = url
  })
}

export async function getVerifiedGravatarURL({ email, size }: { email: string | null | undefined; size: number }) {
  const normalizedEmail = email?.trim().toLowerCase()
  if (!normalizedEmail) return null
  if (typeof window === "undefined") return null
  if (!globalThis.crypto?.subtle) return null

  const cacheKey = `${normalizedEmail}:${size}`
  const knownAvailability = GRAVATAR_AVAILABILITY_CACHE.get(cacheKey)
  const cachedURL = GRAVATAR_URL_CACHE.get(cacheKey)

  if (knownAvailability === false) return null
  if (knownAvailability === true && cachedURL) return cachedURL

  const hash = await digestMessage(normalizedEmail)
  const gravatarURL = `https://gravatar.com/avatar/${hash}/?s=${size}&d=404`
  const isAvailable = await preloadImage(gravatarURL)

  GRAVATAR_AVAILABILITY_CACHE.set(cacheKey, isAvailable)
  if (isAvailable) {
    GRAVATAR_URL_CACHE.set(cacheKey, gravatarURL)
    return gravatarURL
  }

  return null
}
